import { TypographyH2 } from '@talentmesh/ui/components/typography';
import { useEffect, useState } from 'react';
import LoadingTab from '../LoadingTab';
import BillingAddress from './BillingAddress';
import { useBillingInfoClient } from '@/Hooks/ClientHooks';
import useCompanyId from '@/Hooks/UseCompanyId';
import BillingInfo from '@/Models/BillingInfo';
import UIStrings from '@/Utils/UIStrings';

const PaymentTab = () => {
    const client = useBillingInfoClient();
    const companyId = useCompanyId();
    const [billingInfo, setBillingInfo] = useState<BillingInfo>();
    const [isLoadingBillingInfo, setIsLoadingBillingInfo] = useState<boolean>(true);
    const [loadingFailed, setLoadingFailed] = useState<boolean>(false);

    useEffect(() => {
        const doLoadBillingInfo = async () => {
            try {
                const retrievedBillingInfo = await client.getBillingInfoAsync(companyId);
                setBillingInfo(retrievedBillingInfo);
            } catch {
                setLoadingFailed(true);
            } finally {
                setIsLoadingBillingInfo(false);
            }
        };
        doLoadBillingInfo();
    }, []);

    return (
        <LoadingTab isLoading={isLoadingBillingInfo} loadingFailed={loadingFailed}>
            <TypographyH2 className="mb-6">{UIStrings.PaymentSettingsTab}</TypographyH2>
            <div className="flex flex-row gap-4">
                <div className="w-1/2">
                    <BillingAddress billingInfo={billingInfo} setBillingInfo={setBillingInfo} />
                </div>
            </div>
        </LoadingTab>
    );
};

export default PaymentTab;
